<script setup>
import { VueFinalModal } from "vue-final-modal";

const props = defineProps({
  collectionName: {
    type: String,
    required: false,
  },
});

const emit = defineEmits(["close", "submit"]);
</script>

<template>
  <VueFinalModal
    content-transition="vfm-slide-bottom"
    content-class="bg-light p-5 sm:p-10 lg:px-20 w-full sm:w-auto max-w-full"
    class="flex items-center justify-center p-5"
    style="background-color: rgba(0, 0, 0, 0.5)"
    :hide-overlay="true"
  >
    <div>
      <p v-t="'filter.collection.delete.label'" class="block mb-2 text-16 text-dark/50"></p>

      <p
        v-text="props.collectionName"
        class="w-full bg-white sm:w-72 lg:w-96 border text-16 lg:text-20 px-5 py-3 border-primary/40 mb-5"
      ></p>

      <div class="flex gap-x-6 items-center text-16">
        <button
          type="button"
          @click="emit('submit')"
          v-t="'filter.collection.delete.save'"
          class="bg-primary text-white px-5 py-2"
        ></button>

        <button
          @click="emit('close')"
          type="button"
          class="text-left font-medium flex items-center gap-x-3 text-dark/50 hover:text-dark transition-colors"
        >
          <span v-t="'filter.collection.delete.cancel'"></span>
        </button>
      </div>
    </div>
  </VueFinalModal>
</template>
